"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DefaultLoansAPI = exports.DefaultAssetRegistryAPI = exports.DefaultEscrowAPI = exports.DefaultNominationAPI = exports.DefaultRewardsAPI = exports.DefaultFeeAPI = exports.DefaultReplaceAPI = exports.DefaultConstantsAPI = exports.DefaultSystemAPI = exports.DefaultTokensAPI = exports.DefaultBTCRelayAPI = exports.DefaultOracleAPI = exports.DefaultRedeemAPI = exports.DefaultIssueAPI = exports.DefaultVaultsAPI = void 0;
var vaults_1 = require("./vaults");
Object.defineProperty(exports, "DefaultVaultsAPI", { enumerable: true, get: function () { return vaults_1.DefaultVaultsAPI; } });
var issue_1 = require("./issue");
Object.defineProperty(exports, "DefaultIssueAPI", { enumerable: true, get: function () { return issue_1.DefaultIssueAPI; } });
var redeem_1 = require("./redeem");
Object.defineProperty(exports, "DefaultRedeemAPI", { enumerable: true, get: function () { return redeem_1.DefaultRedeemAPI; } });
var oracle_1 = require("./oracle");
Object.defineProperty(exports, "DefaultOracleAPI", { enumerable: true, get: function () { return oracle_1.DefaultOracleAPI; } });
var btc_relay_1 = require("./btc-relay");
Object.defineProperty(exports, "DefaultBTCRelayAPI", { enumerable: true, get: function () { return btc_relay_1.DefaultBTCRelayAPI; } });
var tokens_1 = require("./tokens");
Object.defineProperty(exports, "DefaultTokensAPI", { enumerable: true, get: function () { return tokens_1.DefaultTokensAPI; } });
var system_1 = require("./system");
Object.defineProperty(exports, "DefaultSystemAPI", { enumerable: true, get: function () { return system_1.DefaultSystemAPI; } });
var constants_1 = require("./constants");
Object.defineProperty(exports, "DefaultConstantsAPI", { enumerable: true, get: function () { return constants_1.DefaultConstantsAPI; } });
var replace_1 = require("./replace");
Object.defineProperty(exports, "DefaultReplaceAPI", { enumerable: true, get: function () { return replace_1.DefaultReplaceAPI; } });
var fee_1 = require("./fee");
Object.defineProperty(exports, "DefaultFeeAPI", { enumerable: true, get: function () { return fee_1.DefaultFeeAPI; } });
var rewards_1 = require("./rewards");
Object.defineProperty(exports, "DefaultRewardsAPI", { enumerable: true, get: function () { return rewards_1.DefaultRewardsAPI; } });
var nomination_1 = require("./nomination");
Object.defineProperty(exports, "DefaultNominationAPI", { enumerable: true, get: function () { return nomination_1.DefaultNominationAPI; } });
var escrow_1 = require("./escrow");
Object.defineProperty(exports, "DefaultEscrowAPI", { enumerable: true, get: function () { return escrow_1.DefaultEscrowAPI; } });
var asset_registry_1 = require("./asset-registry");
Object.defineProperty(exports, "DefaultAssetRegistryAPI", { enumerable: true, get: function () { return asset_registry_1.DefaultAssetRegistryAPI; } });
var loans_1 = require("./loans");
Object.defineProperty(exports, "DefaultLoansAPI", { enumerable: true, get: function () { return loans_1.DefaultLoansAPI; } });
__exportStar(require("./transaction"), exports);
//# sourceMappingURL=index.js.map